/* global Modernizr */

Modernizr.addTest('ms', () => !!window.MSStream);

Modernizr.addTest('ipad', () => !!navigator.userAgent.match(/iPad/i) && !Modernizr.ms);
Modernizr.addTest('iphone', () => !!navigator.userAgent.match(/iPhone/i) && !Modernizr.ms);
Modernizr.addTest('ipod', () => !!navigator.userAgent.match(/iPod/i) && !Modernizr.ms);
Modernizr.addTest('ios', () => Modernizr.ipad || Modernizr.ipod || Modernizr.iphone);

Modernizr.addTest('safari', () => !Modernizr.ms && navigator.userAgent.match(/safari/i) && !navigator.userAgent.match(/chrome/i));
Modernizr.addTest('firefox', () => !Modernizr.ms && !!navigator.userAgent.match(/firefox/i));
